import { useEffect, useState } from "react";
import { useAuth } from "@/auth/AuthProvider";
import { getPriorCarriers, type PriorCarrier } from "@/lib/brokerPriorCarriers";
import { messageFor } from "@/lib/errors";

/** Request-scoped options shared by Questions and the application's readback. */
export function usePriorCarriers(needed: boolean) {
  const { authedRequest } = useAuth();
  const [items, setItems] = useState<PriorCarrier[] | null>(null);
  const [problem, setProblem] = useState<string | null>(null);
  const [attempt, setAttempt] = useState(0);
  useEffect(() => {
    if (!needed) return;
    let cancelled = false;
    setProblem(null);
    getPriorCarriers(authedRequest).then(
      ({ items }) => {
        if (!cancelled) setItems(items);
      },
      (err: unknown) => {
        if (!cancelled) setProblem(messageFor(err));
      },
    );
    return () => {
      cancelled = true;
    };
  }, [needed, attempt, authedRequest]);
  return { items, problem, retry: () => setAttempt((n) => n + 1) };
}
